import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import { DialogService } from '@shared/services/dialog-service';
import { CommandService } from '@core/services/command.service';
import {DeleteSurveyCommand, SurveyTemplateExportCommand} from '../../commands/survey.commands';
import { Subject } from 'rxjs';
import {Guid} from 'guid-typescript';
import {ParticleService} from '@core/services/particle.service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {DataSurveyState} from '../../store/reducers/data-survey.reducers';
import {Store} from '@ngrx/store';
import {DeleteSurveyAction} from '../../store/actions/data-survey.actions';
import {takeUntil} from 'rxjs/operators';
import {DownloadFileAction} from '../../../file-manager/store/actions/file-manager.actions';
import {FileManagementService} from '@core/services/file-management.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-data-survey',
  templateUrl: './data-survey.component.html',
  styleUrls: ['./data-survey.component.scss']
})
export class DataSurveyComponent implements OnInit, OnDestroy {

  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  ngUnsubscribe: Subject<void> = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  selectedFieldSectionIndex = 0;
  constructor(private router: Router,
              private dialogService: DialogService,
              private commandService: CommandService,
              private dataSurveyStore: Store<DataSurveyState>,
              private activatedRoute: ActivatedRoute,
              private particleService: ParticleService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService, ) {
    this.sourceKey = 'Data-Survey';
    this.breadcrumbs = [
      <BreadcrumbModel>{
          id : 'DataSurvey',
          title: 'Data Surveys',
          type: 'DataSurvey',
          relativeUrl: 'data-survey'
        },
      <BreadcrumbModel>{
        id: 'ManageTemplate',
        title: 'Templates',
        type: 'DataSurvey',
        relativeUrl: 'data-survey/templates'
      }
      ];
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {

  }

  onGridCellValueChange($event) {
    if ($event.fieldDefinition && $event.fieldDefinition.key === 'title') {
      this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'Edit' && $event.item && $event.item.id) {
      this.router.navigate(['../..', $event.item.id, 'edit'], {relativeTo: this.activatedRoute});
    } else if ($event.action && $event.action.id === 'SendDataSurvey' && $event.item && $event.item.id) {
      this.router.navigateByUrl(`data-survey/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'DesignSurvey' && $event.item && $event.item.id) {
      this.router.navigateByUrl(`data-survey/templates/${$event.item.id}/edit`);
    } else if ($event.action && $event.action.id === 'Delete' && $event.item && $event.item.id) {
      this.dialogService.showYesNoDialog('Delete Survey', 'Are you sure you want to delete this survey?').pipe(takeUntil(this.ngUnsubscribe)).subscribe(result => {
        if (result && result.action === 'OK') {
          const deleteSurveyCommand = new DeleteSurveyCommand([$event.item.id]);
          this.dataSurveyStore.dispatch(new DeleteSurveyAction(deleteSurveyCommand, this.invalidateSubject));
        }
      });
    } else if ($event.action && $event.action.id === 'DownloadJson' && $event.item && $event.item.id) {
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(new SurveyTemplateExportCommand($event.item.id)).pipe().subscribe(response => {
        if (response && response.Payload && response.Payload.Id) {
          this.fileManagementService.downloadClientFileWithId(response.Payload.Id).subscribe(payload => {
            this.fileManagementService.openSaveFileWindow(payload, `Survey Template-${$event.item.cells.title.displayText}.json`);
            this.fuseSplashScreenService.hide();
          });
        }
      });
    } else if ($event.action && $event.action.id === 'CopySurvey' && $event.item && $event.item.id) {
      this.addSurvey($event.item.id);
    }
  }
  addSurvey(copyFromSurveyId: string = null) {
    this.dialogService.showAndStartSurvey('', '', true, {}, copyFromSurveyId);
  }

  importSurvey() {
    this.dialogService.showImportSurveyDialog('', '', true, {});
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  addCustomSurvey() {
    this.router.navigateByUrl(`data-survey/custom/${Guid.create().toString()}`);
  }

  openForms() {
    this.router.navigateByUrl(`data-survey/forms`);
  }
}

